import React, { useState } from 'react';
import Header from './Layout/Header';
import Footer from './Layout/Footer';

function ProfileChoice({ onSelect }) {
  const [siteLang, setSiteLang] = useState('FR');
  const cards = [
    {
      id: 'mannequin',
      label: 'MANNEQUIN',
      sub: 'Mode, fashion & beauté',
      points: ['Mensurations complètes', 'Taille, poitrine, hanches...', 'Format mode & fashion', 'Agence / site web'],
      color: '#FF0066',
    },
    {
      id: 'comedien',
      label: 'COMÉDIEN',
      sub: 'Cinéma, théâtre & publicité',
      points: ['Compétences & langues', 'Type de voix', 'Format casting & pub', 'Agent / contact'],
      color: '#FF0066',
    },
  ];

  return (
    <div style={{ minHeight: '100vh', backgroundColor: '#2a2a2a', display: 'flex', flexDirection: 'column', fontFamily: 'Arial, sans-serif' }}>
      <Header siteLang={siteLang} setSiteLang={setSiteLang} />
      <div style={{ flex: 1, display: 'flex', flexDirection: 'column', alignItems: 'center', justifyContent: 'center', padding: '24px' }}>
      <p style={{ color: '#FF0066', fontSize: '16px', fontWeight: '900', letterSpacing: '6px', marginBottom: '8px' }}>COMPIFY</p>
      <p style={{ color: '#666', fontSize: '11px', letterSpacing: '3px', marginBottom: '48px', textTransform: 'uppercase' }}>Choisissez votre profil</p>

      <div style={{ display: 'flex', gap: '24px', flexWrap: 'wrap', justifyContent: 'center' }}>
        {cards.map(card => (
          <div key={card.id}
            onClick={() => onSelect(card.id)}
            style={{
              width: '280px', cursor: 'pointer',
              backgroundColor: '#1A1A1A',
              border: '1px solid #333',
              transition: 'all 0.2s',
              position: 'relative',
            }}
            onMouseEnter={e => {
              e.currentTarget.style.border = '1px solid #FF0066';
              e.currentTarget.style.transform = 'translateY(-4px)';
              e.currentTarget.style.boxShadow = '0 12px 40px rgba(255,0,102,0.2)';
            }}
            onMouseLeave={e => {
              e.currentTarget.style.border = '1px solid #333';
              e.currentTarget.style.transform = 'translateY(0)';
              e.currentTarget.style.boxShadow = 'none';
            }}
          >
            {/* Coins décoratifs */}
            {[
              { top: 0, left: 0, borderTop: '2px solid #aaa', borderLeft: '2px solid #aaa' },
              { top: 0, right: 0, borderTop: '2px solid #aaa', borderRight: '2px solid #aaa' },
              { bottom: 0, left: 0, borderBottom: '2px solid #aaa', borderLeft: '2px solid #aaa' },
              { bottom: 0, right: 0, borderBottom: '2px solid #aaa', borderRight: '2px solid #aaa' },
            ].map((corner, i) => (
              <div key={i} style={{ position: 'absolute', width: '12px', height: '12px', ...corner }} />
            ))}

            {/* Image placeholder */}
            <div style={{ width: '100%', height: '320px', overflow: 'hidden', borderBottom: '1px solid #333' }}>
              {card.id === 'mannequin'
                ? <img src="/composite-mannequin.jpg" alt="Composite mannequin" style={{ width: '100%', height: '100%', objectFit: 'cover' }} />
                : <img src="/composite-comedien.jpg" alt="Composite comédien" style={{ width: '100%', height: '100%', objectFit: 'cover' }} />
              }
            </div>

            {/* Texte */}
            <div style={{ padding: '20px 24px 24px' }}>
              <p style={{ margin: '0 0 6px', fontSize: '16px', fontWeight: '900', letterSpacing: '3px', color: '#fff' }}>{card.label}</p>
              <p style={{ margin: '0 0 12px', fontSize: '11px', color: '#666', letterSpacing: '1px' }}>{card.sub}</p>
              <ul style={{ margin: '0 0 20px', padding: '0', listStyle: 'none' }}>
                {card.points.map((point, i) => (
                  <li key={i} style={{ display: 'flex', alignItems: 'center', gap: '8px', marginBottom: '6px' }}>
                    <span style={{ color: '#FF0066', fontSize: '10px' }}>→</span>
                    <span style={{ color: '#aaa', fontSize: '11px', letterSpacing: '0.5px' }}>{point}</span>
                  </li>
                ))}
              </ul>
              <button style={{
                width: '100%', padding: '12px',
                backgroundColor: '#FF0066', border: 'none',
                color: '#fff', fontSize: '11px', fontWeight: '700',
                letterSpacing: '2px', cursor: 'pointer',
              }}>
                CHOISIR CE PROFIL
              </button>
            </div>
          </div>
        ))}
      </div>
    </div>
      <Footer />
    </div>
  );
}

export default ProfileChoice;